"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
function toShortDateString(dateTimeValue) {
    return !!dateTimeValue
        ? moment(dateTimeValue).format('M/D/YYYY')
        : '';
}
exports.toShortDateString = toShortDateString;
function toIsoDateString(dateAsString) {
    if (!dateAsString)
        return null;
    var dateAsMoment = moment(dateAsString);
    return dateAsMoment.format("YYYY-MM-DDT00:00:00");
}
exports.toIsoDateString = toIsoDateString;
function toShortDateTimeString(dateTimeValue) {
    return !!dateTimeValue
        ? moment(dateTimeValue).format('M/D/YYYY h:mma')
        : '';
}
exports.toShortDateTimeString = toShortDateTimeString;
function toLongDateString(dateTimeValue, abbreviatedMonthName) {
    var format = abbreviatedMonthName
        ? 'MMM D, YYYY'
        : 'MMMM D, YYYY';
    return !!dateTimeValue
        ? moment(dateTimeValue).format(format)
        : '';
}
exports.toLongDateString = toLongDateString;
function toLongDateTimeString(dateTimeValue, abbreviatedMonthName) {
    var format = abbreviatedMonthName
        ? "MMM D, YYYY h:mma"
        : "MMMM D, YYYY h:mma";
    return !!dateTimeValue ? moment(dateTimeValue).format(format) : "";
}
exports.toLongDateTimeString = toLongDateTimeString;
function toConfiguredDateFormat(dateTimeValue) {
    return !!dateTimeValue
        ? moment(dateTimeValue).format(Pb.DateTimePicker.configuredDisplayDateFormat)
        : '';
}
exports.toConfiguredDateFormat = toConfiguredDateFormat;
function toConfiguredTimeFormat(dateTimeValue) {
    return !!dateTimeValue
        ? moment(dateTimeValue).format(Pb.DateTimePicker.configuredDisplayTimeFormat)
        : '';
}
exports.toConfiguredTimeFormat = toConfiguredTimeFormat;
function toConfiguredDateTimeFormat(dateTimeValue) {
    return !!dateTimeValue
        ? moment(dateTimeValue).format(Pb.DateTimePicker.configuredDisplayDateTimeFormat)
        : '';
}
exports.toConfiguredDateTimeFormat = toConfiguredDateTimeFormat;
